webpackJsonp([1],{

/***/ 25:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

__webpack_require__(34);

var _lodash = __webpack_require__(1);

var _lodash2 = _interopRequireDefault(_lodash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'Tabs',

    data: {
        index: 0,
        navType: null,
        tabs: []
    },

    computed: {
        tabHasCta: function tabHasCta() {
            return !!(this.tabs[this.index] && this.tabs[this.index].tab_button_text && this.tabs[this.index].tab_button_url && this.tabs[this.index].tab_button_url.url);
        },
        tab: function tab() {
            return this.tabs[this.index];
        }
    },

    watch: {
        index: function index(_index) {
            if (this.$refs.labels && this.$refs.labels.length) {
                _lodash2.default.each(this.$refs.labels, function (label) {
                    return label.classList.remove('tabs__label--active');
                });
                this.$refs.labels[_index].classList.add('tabs__label--active');
            }
        }
    },

    mounted: function mounted() {
        var id = this.$el.getAttribute('data-component-id');
        var data = id ? window['_data_' + id] : null;
        var li = this.$el.querySelectorAll('.tabs__top li');

        if (data) {
            // set tabs object to tabs array
            this.tabs = data.tabs;
            this.navType = data.navType;
        }
    },


    methods: {
        toggleList: function toggleList(e) {
            this.index = Array.prototype.indexOf.call(this.$refs.labels, e.target);
        },
        toggleSelect: function toggleSelect(e) {
            this.index = parseInt(this.$refs.select.value);
        }
    }
};

/***/ }),

/***/ 34:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// app-1-ae0e631ce3a5f0a52aaa.js